import { createSlice } from '@reduxjs/toolkit';
import { fetchBuildVersions } from '../../services/activeRunsService';

export const DEFAULT_FILTERS = {
  deviceId: '',
  androidBuildVersion: '',
  iosBuildVersion: '',
  startDate: '',
  endDate: '',
};

const DEFAULT_REPORT_DATA = {
  versions: [],
  flowScenarioDrilldown: [],
};

const DEFAULT_AGENT_SUMMARY_GRAPHICS = {
  completionRate: 0,
  failureRate: 0,
  completedRuns: 0,
  failedRuns: 0,
  totalRuns: 0,
  mostFailedFlow: 'N/A',
  mostFailedScenario: 'N/A',
};

// Initial state
const initialState = {
  loadingFilters: false,
  buildsFilters: {
    android: [],
    ios: [],
  },
  deviceTypeSelected: null,
  runSummaryFilters: DEFAULT_FILTERS,
  errors: '',
  reportData: DEFAULT_REPORT_DATA,
  agentSummary: DEFAULT_AGENT_SUMMARY_GRAPHICS,
};

// Slice
const runSummarySlice = createSlice({
  name: 'runSummary',
  initialState,
  reducers: {
    setBuildsFilters: (state, action) => {
      state.buildsFilters = action.payload;
    },
    setLoadingFilters: (state, action) => {
      state.loadingFilters = action.payload;
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setRunSummaryFilters: (state, action) => {
      state.runSummaryFilters = { ...state.runSummaryFilters, ...action.payload };
    },
    setReportData: (state, action) => {
      state.reportData = action.payload;
    },
    setAgentSummary: (state, action) => {
      state.agentSummary = action.payload;
    },
    setDeviceTypeSelected: (state, action) => {
      state.deviceTypeSelected = action.payload;
    },
    resetAgentSummary: (state) => {
      state.agentSummary = initialState.agentSummary;
    },
    resetReportData: (state) => {
      state.reportData = initialState.reportData;
    },
    resetErrors: (state) => {
      state.errors = initialState.errors;
    },
    resetRunSummaryFilters: (state) => {
      state.runSummaryFilters = initialState.runSummaryFilters;
    },
    reset: () => {
      return initialState;
    },
  },
});

// Export action
export const {
  setBuildsFilters,
  setLoadingFilters,
  setRunSummaryFilters,
  resetRunSummaryFilters,
  setReportData,
  setAgentSummary,
  resetAgentSummary,
  resetReportData,
  setErrors,
  resetErrors,
  reset,
  setDeviceTypeSelected,
} = runSummarySlice.actions;

// Selectors
export const selectBuildsFilters = (state) => state.runSummary.buildsFilters;
export const selectLoadingFilters = (state) => state.runSummary.loadingFilters;
export const selectRunSummaryFilters = (state) => state.runSummary.runSummaryFilters;
export const selectReportData = (state) => state.runSummary.reportData;
export const selectAgentSummary = (state) => state.runSummary.agentSummary;
export const selectDeviceTypeSelected = (state) => state.runSummary.deviceTypeSelected;

// Async thunk for fetching api endpoints
export const getBuildVersionsForFilters = () => async (dispatch) => {
  dispatch(setLoadingFilters(true));
  try {
    const buildVersionsResponse = await fetchBuildVersions();
    const builds =
      buildVersionsResponse?.builds ||
      buildVersionsResponse?.versions ||
      buildVersionsResponse?.data ||
      buildVersionsResponse ||
      {};

    dispatch(setBuildsFilters(builds));
  } catch (error) {
    dispatch(setErrors(error.message));
  } finally {
    dispatch(setLoadingFilters(false));
  }
};

export default runSummarySlice.reducer;
